import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmComponent } from './dialog-confirm/dialog-confirm.component';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { DialogMerchantComponent } from './dialog-merchant/dialog-merchant.component';
import { ComponentType } from '@angular/cdk/overlay';

@Injectable({
  providedIn: 'root',
})
export class DialogUtilService {
  constructor(private dialog: MatDialog) { }

  private confirmElement(title: string, description: string) {
    return this.dialog.open(DialogConfirmComponent, {
      panelClass: 'app-full-bleed-dialog',
      data: { title: title, description: description },
      width: '500px',
    });
  }

  openConfirmDialog(title: string, description: string): Observable<Boolean> {
    const dialogRef = this.confirmElement(title, description);

    return dialogRef.afterClosed().pipe(
      take(1),
      map((res) => {
        return res;
      })
    );
  }

  private confirmMerchantElement() {
    return this.dialog.open(DialogMerchantComponent, {
      panelClass: 'app-full-bleed-dialog',
      data: null,
      width: '500px',
      disableClose: true,
    });
  }

  openMerchantDialog(): Observable<Boolean> {
    const dialogRef = this.confirmMerchantElement();

    return dialogRef.afterClosed().pipe(
      take(1),
      map((res) => {
        return res;
      })
    );
  }

  openAccountSuspendedDialog(accountStatus: string = 'DISABLED'): Observable<boolean> {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      panelClass: 'app-full-bleed-dialog',
      width: '400px',
      disableClose: false,
      data: {
        centeredLayout: true,
        description: 'Your account has been suspended or terminated. Login access is currently disabled. Please contact support for assistance.',
        confirmButtonText: 'OK',
        icon: 'warning',
        iconColor: 'warn'
      }
    });

    return dialogRef.afterClosed().pipe(
      take(1),
      map((res) => res)
    );
  }

  private getPageDialog(
    component: ComponentType<any>,
    data?: any,
    height?: string,
    width?: string,
    disableClose?: boolean
  ) {
    return this.dialog.open(component, {
      panelClass: 'app-full-bleed-dialog',
      data: data,
      width: height ? height : '1100px',
      height: width ? width : '600px',
      disableClose: disableClose ? disableClose : true,
    });
  }

  openPageDialog(
    component: ComponentType<any>,
    data?: any,
    height?: string,
    width?: string,
    disableClose?: boolean
  ): Observable<Boolean> {
    const dialogRef = this.getPageDialog(component, data);

    return dialogRef.afterClosed().pipe(
      take(1),
      map((res) => {
        return res;
      })
    );
  }
}
